import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'extensao');

const extensaoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}` },
  listarModalidadesAtivas: { method: 'GET', url: `${basePath}/modalidades?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}` },
  listarQuantidadeMaiorAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}` },
  listarPorUsuario: { method: 'GET', url: `${basePath}?tamanhoPagina=10&numeroPagina=1&nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&usuarioLogado=true&colunaOrdenacao=nom_extensao` },
  listarAutocomplete: { method: 'GET', url: `${basePath}?autocomplete={autocomplete}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  listarAtivosPorRepresentante: { method: 'GET', url: `${basePath}/por-representante?&nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao` },
};

export default resource => resource(`${basePath}`, {}, extensaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/extensao.js